import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	CTA,
	ExternalLinkIndicator,
	Text,
	TokenTextAppearance,
	TextTag,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import './UserVerification.scss';
import { Modal } from '../../models/Modal';
import { VehicleObject } from '../../models/Vehicle';

export default function UserVerification({ state, close }: Modal<UserVerificationProps>) {
	const { signIn, getWeConnectUrl, trackingService, isLoggedIn, vehicle, t } = state;

	const vinCheckTrackingButton = () => {
		if (trackingService) {
			trackingService.track('VWBasic_Button_Click', {
				eventInfo: {
					eventAction: 'VWBasic_Button_Click',
					pageId: window.location.href,
					pageName: 'Vin Details',
					contentId: 'vinDetails.userVerification',
					sectionName: 'userVerification',
					brand: 'passenger',
				},
				user: {
					loginStatus: isLoggedIn,
					browserResolutionHeight: window.innerHeight,
					browserResolutionWidth: window.innerWidth,
					browserResolutionOrientation: window.innerHeight >= window.innerWidth ? 'v' : 'h',
				},
				personalization: {
					personalizable: false,
				},
				configuration: {
					CarlineName: vehicle.data.modelCarLine,
					SalesgroupName: vehicle.data.modelSalesGroup,
				},
				link: {
					name: 'authServiceLogin',
				},
			});
		}
	};

	const vinCheckTrackingLayerLoad = () => {
		if (trackingService) {
			trackingService.track('VWBasic_Layer_Load', {
				eventInfo: {
					eventAction: 'VWBasic_Layer_Load',
					pageId: window.location.href,
					pageName: 'Vin Details',
					contentId: 'vinDetails.userVerification',
					sectionName: 'userVerification',
					brand: 'passenger',
				},
				user: {
					loginStatus: isLoggedIn,
					browserResolutionHeight: window.innerHeight,
					browserResolutionWidth: window.innerWidth,
					browserResolutionOrientation: window.innerHeight >= window.innerWidth ? 'v' : 'h',
				},
				configuration: {
					CarlineName: vehicle.data.modelCarLine,
					SalesgroupName: vehicle.data.modelSalesGroup,
				},
			});
		}
	};

	vinCheckTrackingLayerLoad();

	return (
		<ThemeProvider theme="main">
			<Container
				shrinkContent
				wrap="always"
				gutter={ContainerGutter.dynamic0100}
				padding={{ left: ContainerPadding.grid002, right: ContainerPadding.grid002 }}
			>
				<Text appearance={TokenTextAppearance.headline400}>{t('userVerification.title')}</Text>

				<>
					<Text tag={TextTag.p}>{t('userVerification.paragraph1')}</Text>
					<Text tag={TextTag.p}>{t('userVerification.paragraph2')}</Text>
					<Text tag={TextTag.span}>{t('userVerification.weConnect')} </Text>
					<CTA emphasis="tertiary" tag="a" href={getWeConnectUrl()} target="_blank">
						<Text appearance={TokenTextAppearance.copy200} tag={TextTag.span}>
							{t('userVerification.here')}. <ExternalLinkIndicator />
						</Text>
					</CTA>
				</>

				<Container
					gutter={ContainerGutter.dynamic0050}
					stretchContent={{ [Breakpoints.default]: true, [Breakpoints.b560]: false }}
					wrap={{ [Breakpoints.default]: 'always', [Breakpoints.b560]: 'never' }}
				>
					<CTA stretchContent tag="button" emphasis="secondary" onClick={close}>
						{t('general.close')}
					</CTA>

					<CTA
						stretchContent
						tag="a"
						onClick={() => {
							vinCheckTrackingButton();
							signIn();
							close();
						}}
					>
						{t('general.login')} <ExternalLinkIndicator />
					</CTA>
				</Container>
			</Container>
		</ThemeProvider>
	);
}

export interface UserVerificationProps {
	getWeConnectUrl: () => string;
	signIn: () => void;
	trackingService: any;
	isLoggedIn: boolean;
	vehicle: VehicleObject;
	tracking: {
		contentId: string;
		sectionName: string;
	};
	t: any;
}
